import { render, staticRenderFns } from "./MobileBanner.vue?vue&type=template&id=b054884c&scoped=true"
import script from "./MobileBanner.vue?vue&type=script&lang=js"
export * from "./MobileBanner.vue?vue&type=script&lang=js"
import style0 from "./MobileBanner.vue?vue&type=style&index=0&id=b054884c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b054884c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b054884c')) {
      api.createRecord('b054884c', component.options)
    } else {
      api.reload('b054884c', component.options)
    }
    module.hot.accept("./MobileBanner.vue?vue&type=template&id=b054884c&scoped=true", function () {
      api.rerender('b054884c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/mobile/MobileBanner.vue"
export default component.exports